export enum UserBlocker {
    /**
     * The user has not accepted the terms of service and has no circle
     */
    Tos = 'tos',
    /**
     * The user is not a sponsored user
     */
    Unsponsored = 'unsponsored',
    /**
     * The user needs to link their SSO account
     */
    LinkingSSO = 'linkingSSO',
    /**
     * A first-time user has an invitation that they might redeem
     */
    ReceivingInvitation = 'receivingInvitation',
    /**
     * Used to determine if an unsponsored user needs to report their permanent residence
     */
    CountryUnsponsored = 'countryUnsponsored',
    /**
     * Used to determine if a sponsored user needs to report their permanent residence
     */
    CountrySponsored = 'countrySponsored',
    /**
     * Used to determine if the user needs to report their permanent residence
     */
    CommunicationsPreference = 'communicationsPreference',
    /**
     * Used to determine if the user needs to accept CCHD
     */
    CCHDUnsponsored = 'cchdUnsponsored',
    /**
     * Used to determine if the user needs to accept CCHD after sponsorship
     */
    CCHDSponsored = 'cchdSponsored',
    /**
     * Used to determine if the user needs to accept UK after sponsorship
     */
    UK = 'uk',
    /**
     * Used to determine if the user needs to reconsent to TOS/Privacy, CHDPP, or Partner Authorization
     */
    Reconsent = 'reconsent',
    /**
     * Used to determine if the user should be brought to the loss of sponsorship flow
     */
    Expired = 'expired',
    /**
     * The user is not a sponsored user
     */
    PostMentalHealthScreeningPromo = 'postMentalHealthScreeningPromo',
}
